var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('main',{staticClass:"main",attrs:{"id":"top"}},[_c('div',{staticClass:"container-fluid px-0",attrs:{"data-layout":"container"}},[_c('notifications',{attrs:{"group":"iasc"}}),_vm._l((_vm.avisos),function(aviso,x){return _c('AvisosApp',{key:x,attrs:{"indx":x,"aviso":aviso}})}),_c('router-view')],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }